/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_e36148a6"]'><div><div :class='["picker-demo-title"]'>Config delay step:</div><cube-time-picker :delay="(delay)"/></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_e36148a6"}'>
.picker-demo-title
  margin-bottom: 8px
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_e36148a6"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_e36148a6"}
  /** script content **/
  require("./config-delay-picker.mpx.js?isComponent&outputPath=components%2Fconfig-delay-pickere36148a6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./config-delay-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fconfig-delay-pickere36148a6%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_e36148a6"],
    ctorType: "component",
    outputPath: "components/config-delay-pickere36148a6/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-time-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/time-picker/index.mpx?isComponent&outputPath=components%2Findex057b2bbb%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>